






















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class UpdateEmailTemplate extends Vue {
     createnew: any;

    // Props
    @Prop({ default() { return {}; } })
    item!: any;

    // Data
    dialog = false;
    loading = false;
    form = {
        name: this.item.name,
        description: this.item.description,
        subject: this.item.subject,
        template: this.item.template,
        data: this.item.data,
    };

    // Methods
    public async SubmitUpdate() {
        try {
            this.loading = true;
            this.item.name = this.form.name;
            this.item.description = this.form.description;
            this.item.subject = this.form.subject;
            this.item.template = this.form.template;
            this.item.data = this.form.data;
            await this.item.patch();
            this.$emit('success');
            this.dialog = false;
        } catch(err) {
            this.$emit('error', err);
        } finally {
            this.loading = false;
        }
    }
}
